import { DataForm, DataFormField } from '@tencent/data-schema/lib/vue-ui/DataForm';
import { isExprObject } from '@tencent/data-schema-core/lib/utils/eval';
import { propPanelMixin } from '../../../helpers';
import { getRelatedPropsOfBinding, isSuitableForBinding } from '../../../utils/bindings';
import cloneDeep from "lodash-es/cloneDeep";
import { debounce, forEach, groupBy, isEqual, keyBy, omitBy, get, isUndefined } from "lodash-es";
import { DND_TYPE_DATA_PATH, INJECT_PROPPANEL_RUNEXPR } from '../../../utils/consts';
import ExprInput from '../../../comps/ExprInput';
import WAccordion from '../../../builtin/components/Accordion';
import WCard from '../../../builtin/components/Card';
import PropPanelFooter from './footer';
import { verifyDataSchemaPath } from "../../../../lib/utils/dataSchema/verifyDataSchemaPath";
import FieldLabel from "../../../../lib/comps/PropPanel/components/FieldLabel";
import { deepInterop, tryEval } from "../../../../lib/utils";
import { getPropPanelContextOptions } from "../../../../lib/comps/PropPanel/PropPanel/extraCtx";
import ExprInputAIProvider from "../../../../lib/comps/ExprInput/addon/ExprInputAiProvider";
const __script_base__ = {
  name: 'ComponentDefaultPropPanel',
  mixins: [propPanelMixin],
  data() {
    return {
      compProps: null,
      bindingHoveringPropId: '',
      visiblePropFieldIds: [],
      overlayStyle: Object.freeze({
        pointerEvents: 'none'
      }),
      renderPanel: false,
      propUIFlagsLUT: {}
    };
  },
  provide() {
    return {
      [INJECT_PROPPANEL_RUNEXPR]: this.runExpr
    };
  },
  components: {
    ExprInputAIProvider,
    FieldLabel,
    DataForm,
    DataFormField,
    ExprInput,
    WAccordion,
    WCard,
    PropPanelFooter
  },
  computed: {
    dataSchemaContextOptions() {
      return getPropPanelContextOptions(this);
    },
    /**
     * @return {Record<string, UICore.ComponentBindingMeta>} key is propId
     */
    validBindingDropTargets() {
      const bindingDataStub = this.designer.currentOperation === 'binding' && this.designer.currentBindingDataStub;
      if (!bindingDataStub) return {};
      const {
        schema
      } = bindingDataStub;
      const ans = {};
      forEach(this.bindingMetaLUT, /** @param {UICore.ComponentBindingMeta} meta */meta => {
        if (isSuitableForBinding(meta, schema)) {
          getRelatedPropsOfBinding(meta).forEach(propId => {
            ans[propId] = meta;
          });
        }
      });
      return ans;
    },
    bindingMetaLUT() {
      return keyBy(this.compMeta.bindings, 'id');
    },
    prop2bindingMetaLUT() {
      var _this$compMeta;
      const ans = {};
      (_this$compMeta = this.compMeta) === null || _this$compMeta === void 0 || (_this$compMeta = _this$compMeta.bindings) === null || _this$compMeta === void 0 || _this$compMeta.forEach( /** @param {UICore.ComponentBindingMeta} meta */meta => {
        getRelatedPropsOfBinding(meta).forEach(propId => {
          ans[propId] = meta;
        });
      });
      return ans;
    },
    propFlagsLUT() {
      var _this$comp;
      const ans = {};
      const {
        compProps
      } = this;
      const currentBindings = (_this$comp = this.comp) === null || _this$comp === void 0 ? void 0 : _this$comp.bindings;
      this.compPropsSchema.fields.forEach(schema => {
        var _this$dataSchemaConte;
        const {
          id
        } = schema;
        const bindingMeta = this.prop2bindingMetaLUT[id];
        const isPropValueExprObject = isExprObject(compProps[id]);
        const isBinded = !!(bindingMeta && currentBindings && bindingMeta.id in currentBindings);
        const isUnbindable = !!(isBinded && !bindingMeta.required);
        const isBindable = !isBinded && bindingMeta;
        const uiType = get(schema, 'ui.type');
        // 拿到自定义ui传给dataFormfield内部使用的那个组件的meta 并判断上面有没有hideLabel
        const isHideLabel = !!((_this$dataSchemaConte = this.dataSchemaContextOptions.components.find(compObj => compObj.id === uiType)) !== null && _this$dataSchemaConte !== void 0 && _this$dataSchemaConte.hideLabel)
        // 必须是用了自定义输入组件才生效
        && !isPropValueExprObject;
        const isExprBindable = (() => {
          if (isBindable && bindingMeta.event && !(currentBindings !== null && currentBindings !== void 0 && currentBindings[bindingMeta.id])) {
            if (isPropValueExprObject && !!compProps[id].$expr && verifyDataSchemaPath(compProps[id].$expr)) {
              try {
                // getStubAtPath 可能会抛异常
                const stub = this.designer.renderer.getStubAtPath(compProps[id].$expr);
                return stub && stub.path === compProps[id].$expr && stub.path;
              } catch (e) {
                return null;
              }
            }
            if (typeof compProps[id] === 'string') {
              var _compProps$id$match;
              const dataPath = (_compProps$id$match = compProps[id].match(/^\s*{{\s*(\S+)\s*}}\s*$/)) === null || _compProps$id$match === void 0 ? void 0 : _compProps$id$match[1];
              if (dataPath && verifyDataSchemaPath(dataPath)) {
                try {
                  const stub = this.designer.renderer.getStubAtPath(dataPath);
                  return stub && stub.path === dataPath && stub.path;
                } catch (e) {
                  return null;
                }
              }
            }
          }
          return null;
        })();
        ans[id] = {
          isExprObject: isPropValueExprObject,
          isUnbindable,
          isBinded,
          isBindable,
          isCheckbox: !(isPropValueExprObject || isBinded || bindingMeta !== null && bindingMeta !== void 0 && bindingMeta.required) && schema.type === 'boolean',
          // 样式上的
          isHideLabel,
          isExprBindable
        };
      });
      return ans;
    },
    propFieldGroups() {
      /** @type {{
       prop2bindingMetaLUT: Record<string, UICore.ComponentBindingMeta>,
       compPropsSchema: UICore.CompletedComponentMeta['propsSchema']
      }} */
      const {
        prop2bindingMetaLUT,
        compPropsSchema
      } = this;
      try {
        const {
          comp,
          compPath,
          visiblePropFieldIds
        } = this;
        const currentBindings = comp.bindings || {};
        const completedFields = compPropsSchema.fields.filter(x => !x.hidden && visiblePropFieldIds.includes(x.id)).map(schema => {
          const propId = schema.id;
          /** @type {UICore.ComponentBindingMeta} */
          const bindingMeta = prop2bindingMetaLUT[propId];
          let {
            ui
          } = schema;
          let _usingBindingEdit = false;
          if (bindingMeta && (bindingMeta.required || bindingMeta.id in currentBindings)) {
            ui = {
              type: 'BindingEdit',
              settings: {
                comp,
                compPath,
                bindingMeta
              }
            };
            _usingBindingEdit = true;
          }
          return {
            ...schema,
            ui,
            _usingBindingEdit,
            group: schema.group || ''
          };
        });
        return groupBy(completedFields, 'group');
      } catch (err) {
        return [];
      }
    },
    defaultProps() {
      var _this$compMeta2;
      this.compPath; // Vue Dep
      return cloneDeep((_this$compMeta2 = this.compMeta) === null || _this$compMeta2 === void 0 ? void 0 : _this$compMeta2.defaultProps) || {};
    },
    compPropsSchema() {
      var _this$compMeta3;
      return (_this$compMeta3 = this.compMeta) === null || _this$compMeta3 === void 0 ? void 0 : _this$compMeta3.propsSchema;
    }
  },
  methods: {
    runExpr(code, type) {
      const {
        renderer
      } = this.designer;
      if (type === 'javascript') {
        return tryEval(code, renderer);
      }
      return deepInterop(code, renderer);
    },
    hideExprBindDialog(e, propField) {
      var _e$relatedTarget;
      if (!(e !== null && e !== void 0 && (_e$relatedTarget = e.relatedTarget) !== null && _e$relatedTarget !== void 0 && _e$relatedTarget.matches('.uc-propForm-bindDialog, .uc-propForm-bindDialog *'))) {
        this.$set(this.propUIFlagsLUT[propField.id], 'showExprBindDialog', false);
      }
      this.designer.activeCompProp = '';
      this.notifyChange();
    },
    delayAndHideExprBindDialog(propField) {
      setTimeout(() => this.$set(this.propUIFlagsLUT[propField.id], 'showExprBindDialog', false), 200);
    },
    showExprBindDialog(propField) {
      var _propFlagsLUT$propId;
      const {
        id: propId
      } = propField;
      const {
        propFlagsLUT,
        propUIFlagsLUT
      } = this;
      if (!!((_propFlagsLUT$propId = propFlagsLUT[propId]) !== null && _propFlagsLUT$propId !== void 0 && _propFlagsLUT$propId.isExprBindable)) {
        this.$set(propUIFlagsLUT[propField.id], 'showExprBindDialog', true);
      }
      this.designer.activeCompProp = propId;
    },
    switchExprToBinding(ev, propField) {
      var _this$propFlagsLUT$pr;
      const {
        id: propId
      } = propField;
      const binding = this.prop2bindingMetaLUT[propId];
      if (!binding) return;
      ev.preventDefault();
      ev.stopPropagation();
      const dataPath = (_this$propFlagsLUT$pr = this.propFlagsLUT[propField.id]) === null || _this$propFlagsLUT$pr === void 0 ? void 0 : _this$propFlagsLUT$pr.isExprBindable;
      this.designer.setBinding(this.compPath, binding.id, dataPath);
      this.$set(this.propUIFlagsLUT[propField.id], 'showExprBindDialog', false);
      this.updateCompPropDebounced(propId, '');
    },
    notifyChange() {
      this.fullyUpdateProps();
    },
    async fullyUpdateProps() {
      // 首先，单个输入框的修改是被 debounced 的，但是这里是全量提交修改，所以那些定时器已经没用了
      forEach(this._pendingTimers, clearTimeout);
      this._pendingTimers = {};

      // 然后就是全量提交
      // 去掉默认值们
      const {
        defaultProps
      } = this;
      const comittedProps = !defaultProps ? this.compProps : omitBy(this.compProps, (v, k) => {
        const defaultValue = defaultProps[k];
        return typeof defaultValue !== 'undefined' && isEqual(v, defaultValue);
      });
      if (isEqual(this.comp.props, comittedProps)) return;
      await this.modifyComp(e => {
        this.$set(e, 'props', cloneDeep(comittedProps));
      });
      await this.uc.flushPageletsChange();
    },
    handleFormChangeEvent(n, o, changeTrace) {
      const changePoint = changeTrace[changeTrace.length - 2];
      const changedPropName = changePoint === null || changePoint === void 0 ? void 0 : changePoint.path;
      if (!changedPropName) return;

      // 能够获取到具体修改了哪个 prop，可以只修改这个 prop 就行
      this.updateCompPropDebounced(changedPropName, changePoint.value);
    },
    // 带 debounce 的 updateCompProp
    updateCompPropDebounced(prop, value) {
      if (prop in this._pendingTimers) {
        clearTimeout(this._pendingTimers[prop]);
      }
      this._pendingTimers[prop] = setTimeout(() => {
        this.updateCompProp(prop, cloneDeep(value));
        delete this._pendingTimers[prop];
      }, 300);
    },
    // 拖拽绑定！
    handlePropFieldDragOver(ev, propId) {
      if (!this.validBindingDropTargets[propId]) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.bindingHoveringPropId = propId;
    },
    handlePropFieldDrop(ev) {
      const binding = this.validBindingDropTargets[this.bindingHoveringPropId];
      if (!binding) return;
      ev.preventDefault();
      ev.stopPropagation();
      this.designer.setBinding(this.compPath, binding.id, ev.dataTransfer.getData(DND_TYPE_DATA_PATH));
      this.bindingHoveringPropId = '';
    },
    handleLabelClick(field) {
      if (field.type === 'boolean') {
        this.compProps[field.id] = !this.compProps[field.id];
      }
    },
    updateVisiblePropFieldIdsInternal() {
      let ans = [];
      try {
        const r = this.$refs.dataForm.rootStub.getFields();
        ans = [...r.fields.map(x => x.id), ...r.candidates.map(x => x.id)].filter(Boolean);
      } catch (err) {
        var _this$compPropsSchema;
        ans = ((_this$compPropsSchema = this.compPropsSchema) === null || _this$compPropsSchema === void 0 || (_this$compPropsSchema = _this$compPropsSchema.fields) === null || _this$compPropsSchema === void 0 ? void 0 : _this$compPropsSchema.map(x => x.id)) || [];
      }
      if (!isEqual(ans, this.visiblePropFieldIds)) this.visiblePropFieldIds = ans;
    },
    resetProp(id) {
      this.compProps[id] = cloneDeep(this.defaultProps[id]);
    },
    isExprObject,
    toggleExprMode(id) {
      const oldValue = this.compProps[id];
      if (isExprObject(oldValue)) {
        // 如果当前已经是 expr模式，就重置为 prop 默认值
        try {
          this.compProps[id] = JSON.parse(oldValue.$expr);
        } catch (err) {
          this.compProps[id] = cloneDeep(this.defaultProps[id]);
        }
      } else {
        // 否则以当前的值 JSON stringify 一下，然后变成 expr
        this.compProps[id] = {
          $expr: JSON.stringify(oldValue, null, 2)
        };
      }
      setTimeout(() => {
        var _this$$refs$bindDialo;
        (_this$$refs$bindDialo = this.$refs.bindDialog) === null || _this$$refs$bindDialo === void 0 || (_this$$refs$bindDialo = _this$$refs$bindDialo[0]) === null || _this$$refs$bindDialo === void 0 || _this$$refs$bindDialo.focus();
      }, 100);
    },
    async unbindProp(id) {
      var _this$propFlagsLUT$id;
      if (!((_this$propFlagsLUT$id = this.propFlagsLUT[id]) !== null && _this$propFlagsLUT$id !== void 0 && _this$propFlagsLUT$id.isUnbindable)) return;
      const binding = this.prop2bindingMetaLUT[id];
      await this.designer.setBinding(this.compPath, binding.id, '');
    },
    async createBindFor(target, propId) {
      const bindingMeta = this.prop2bindingMetaLUT[propId];
      await this.designer.openDataPathSelector({
        place: target,
        width: 300,
        filter: bindingMeta.checkData
      }).then(async dataPath => {
        if (!dataPath) return;
        await this.designer.setBinding(this.compPath, bindingMeta.id, dataPath);
      });
    },
    onDataFormMounted() {
      this.updateVisiblePropFieldIds();

      // 不是很理解上面为什么要debounce100 所以下面重新同步调用一下
      this.$nextTick(() => {
        this.updateVisiblePropFieldIdsInternal();
        this.renderPanel = true;
      });
    }
  },
  created() {
    var _this$compPropsSchema2;
    this._pendingTimers = {};
    this.visiblePropFieldIds = ((_this$compPropsSchema2 = this.compPropsSchema) === null || _this$compPropsSchema2 === void 0 || (_this$compPropsSchema2 = _this$compPropsSchema2.fields) === null || _this$compPropsSchema2 === void 0 ? void 0 : _this$compPropsSchema2.map(x => x.id)) || []; // 初始 fallback
    this.updateVisiblePropFieldIds = debounce(this.updateVisiblePropFieldIdsInternal, 100);
    this.$watch(() => [this.comp, this.defaultProps], /** @param {[ UICore.Comp, UICore.ComponentMeta ]} arg1 */
    ([comp, defaultProps]) => {
      const newProps = {
        ...defaultProps,
        ...omitBy(comp.props, isUndefined)
      };

      // 为什么要 clone，因为有的人总是喜欢糊一个对象作为 prop 然后不遵守 immutable
      if (!isEqual(newProps, this.compProps)) this.compProps = cloneDeep(newProps);
    }, {
      immediate: true,
      deep: true
    });
    this.$watch(() => this.compPropsSchema.fields, () => {
      this.propUIFlagsLUT = (this.compPropsSchema.fields || []).reduce((prev, {
        id
      }) => {
        Object.assign(prev, {
          [id]: {
            showExprBindDialog: false
          }
        });
        return prev;
      }, {});
    }, {
      immediate: true
    });
  },
  beforeDestroy() {
    this.updateVisiblePropFieldIds.cancel();
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    key: _vm.compPath,
    staticClass: "uc-propForm",
    on: {
      keydown: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.notifyChange.apply(null, arguments);
      },
      click: _vm.notifyChange,
      "!blur": function ($event) {
        return _vm.notifyChange.apply(null, arguments);
      }
    }
  }, [_vm.compPropsSchema ? _c("DataForm", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.renderPanel,
      expression: "renderPanel"
    }],
    ref: "dataForm",
    staticClass: "uc-dataForm-vertical",
    attrs: {
      schema: _vm.compPropsSchema,
      "context-options": _vm.dataSchemaContextOptions
    },
    on: {
      change: _vm.handleFormChangeEvent,
      "hook:mounted": _vm.onDataFormMounted,
      "hook:updated": _vm.updateVisiblePropFieldIds
    },
    model: {
      value: _vm.compProps,
      callback: function ($$v) {
        _vm.compProps = $$v;
      },
      expression: "compProps"
    }
  }, _vm._l(_vm.propFieldGroups, function (propFields, key) {
    return _c(key ? "WAccordion" : "WCard", {
      key: "propsGroup:" + key,
      tag: "component",
      staticStyle: {
        "margin-bottom": "12px"
      },
      attrs: {
        title: key,
        "with-border": ""
      }
    }, _vm._l(propFields, function (propField) {
      return _c("ExprInputAIProvider", {
        key: propField.id,
        staticClass: "uc-propForm-item",
        class: {
          isBindingDropZone: !!_vm.validBindingDropTargets[propField.id],
          isAboutToBind: _vm.bindingHoveringPropId === propField.id,
          isCheckbox: _vm.propFlagsLUT[propField.id].isCheckbox
        },
        attrs: {
          field: propField
        },
        on: {
          "!dragover": function ($event) {
            return _vm.handlePropFieldDragOver($event, propField.id);
          },
          "!dragleave": function ($event) {
            _vm.bindingHoveringPropId = "";
          },
          "!drop": function ($event) {
            return _vm.handlePropFieldDrop.apply(null, arguments);
          }
        }
      }, [_c("div", {
        staticClass: "uc-propForm-label"
      }, [!_vm.propFlagsLUT[propField.id].isHideLabel ? _c("field-label", {
        attrs: {
          text: propField.title || propField.id,
          schema: {
            description: propField.description
          },
          compact: true
        },
        on: {
          click: function ($event) {
            return _vm.handleLabelClick(propField);
          }
        }
      }) : _vm._e(), _vm._v(" "), _c("div", {
        staticStyle: {
          flex: "1"
        }
      }), _vm._v(" "), _vm.propFlagsLUT[propField.id].isBindable ? _c("a-tooltip", {
        staticClass: "uc-propForm-actionButton",
        attrs: {
          title: "添加绑定到 " + propField.id,
          "overlay-style": _vm.overlayStyle
        },
        on: {
          click: function ($event) {
            return _vm.createBindFor($event.target, propField.id);
          }
        }
      }, [_c("div", [_c("i", {
        staticClass: "fa fa-link",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e(), _vm._v(" "), _vm.propFlagsLUT[propField.id].isUnbindable ? _c("a-tooltip", {
        staticClass: "uc-propForm-actionButton",
        attrs: {
          title: "取消 " + propField.id + " 的绑定",
          "overlay-style": _vm.overlayStyle
        },
        on: {
          click: function ($event) {
            return _vm.unbindProp(propField.id);
          }
        }
      }, [_c("div", [_c("i", {
        staticClass: "fa fa-unlink",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e(), _vm._v(" "), !_vm.propFlagsLUT[propField.id].isBinded && propField["uc:allowReset"] ? _c("a-tooltip", {
        staticClass: "uc-propForm-actionButton",
        attrs: {
          title: "重置 " + propField.id + " 为初始值",
          "overlay-style": {
            visibility: _vm.designer.skeletonStyle.hidePropPanelTooltip ? "hidden" : "",
            "pointer-events": "none"
          }
        },
        on: {
          click: function ($event) {
            return _vm.resetProp(propField.id);
          }
        }
      }, [_c("div", [_c("i", {
        staticClass: "fa fa-undo",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e(), _vm._v(" "), _vm.propFlagsLUT[propField.id].isExprObject || !propField._usingBindingEdit && propField["uc:allowExpr"] ? _c("a-tooltip", {
        staticClass: "uc-propForm-actionButton",
        class: {
          isActive: _vm.propFlagsLUT[propField.id].isExprObject
        },
        attrs: {
          "overlay-style": {
            visibility: _vm.designer.skeletonStyle.hidePropPanelTooltip ? "hidden" : "",
            "pointer-events": "none"
          }
        },
        on: {
          click: function ($event) {
            return _vm.toggleExprMode(propField.id);
          }
        }
      }, [_c("div", {
        attrs: {
          slot: "title"
        },
        slot: "title"
      }, [_c("p", [_vm._v("使用 JS 表达式 动态决定 " + _vm._s(propField.id) + " 的值")]), _vm._v(" "), _c("ul", [_c("li", [_vm._v("可以直接引用 “数据源” 面板里的变量")]), _vm._v(" "), _c("li", [_vm._v("引用变量时，无需、也不支持 双花括号")]), _vm._v(" "), _c("li", [_vm._v("单个表达式不使用引号可直接返回结果")]), _vm._v(" "), _c("li", [_vm._v("多行代码通过return返回想要的结果")])]), _vm._v(" "), _c("div", {
        staticStyle: {
          color: "#FF0"
        }
      }, [_vm._v("\n                这是个高级功能，若不理解请勿使用\n              ")])]), _vm._v(" "), _c("div", [_c("i", {
        staticClass: "fa fa-cogs",
        attrs: {
          "aria-hidden": "true"
        }
      })])]) : _vm._e()], 1), _vm._v(" "), _c("a-tooltip", {
        attrs: {
          visible: !!_vm.propFlagsLUT[propField.id].isExprBindable && _vm.propUIFlagsLUT[propField.id] && _vm.propUIFlagsLUT[propField.id].showExprBindDialog,
          "destroy-tooltip-on-hide": true,
          placement: "leftTop"
        }
      }, [_c("div", {
        ref: "bindDialog",
        refInFor: true,
        staticClass: "uc-propForm-bindDialog",
        attrs: {
          slot: "title",
          tabindex: "0"
        },
        on: {
          blur: function ($event) {
            return _vm.delayAndHideExprBindDialog(propField);
          }
        },
        slot: "title"
      }, [_c("div", [_vm._v(" 你使用的是"), _c("span", {
        staticStyle: {
          color: "#EE9D41"
        }
      }, [_vm._v("单向绑定模式")])]), _vm._v(" "), _c("div", [_vm._v(" 输入和修改不会储存下来 ")]), _vm._v(" "), _c("div", {
        staticStyle: {
          margin: "10px 0 5px 60px"
        }
      }, [_c("a-button", {
        attrs: {
          size: "small"
        },
        on: {
          click: function ($event) {
            return _vm.switchExprToBinding($event, propField);
          }
        }
      }, [_c("i", {
        staticClass: "fa fa-link",
        attrs: {
          "aria-hidden": "true"
        }
      }), _vm._v(" 切换为双向绑定\n              ")])], 1)]), _vm._v(" "), !_vm.propFlagsLUT[propField.id].isBinded && _vm.propFlagsLUT[propField.id].isExprObject ? _c("div", {
        staticClass: "uc-propForm-input"
      }, [_c("ExprInput", {
        attrs: {
          info: propField,
          "multiple-line": true,
          "notify-void-return": true
        },
        nativeOn: {
          focusin: function ($event) {
            return _vm.showExprBindDialog(propField);
          },
          focusout: function ($event) {
            return _vm.hideExprBindDialog($event, propField);
          }
        },
        model: {
          value: _vm.compProps[propField.id].$expr,
          callback: function ($$v) {
            _vm.$set(_vm.compProps[propField.id], "$expr", $$v);
          },
          expression: "compProps[propField.id].$expr"
        }
      })], 1) : _c("DataFormField", {
        staticClass: "uc-propForm-input",
        attrs: {
          ui: propField.ui,
          path: propField.id,
          label: ""
        },
        nativeOn: {
          focusin: function ($event) {
            return _vm.showExprBindDialog(propField);
          },
          focusout: function ($event) {
            return _vm.hideExprBindDialog($event, propField);
          }
        }
      })], 1)], 1);
    }), 1);
  }), 1) : _vm._e(), _vm._v(" "), _c("PropPanelFooter", {
    attrs: {
      comp: _vm.comp
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/PropPanel/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);